import axios from 'axios';
import { ALL_FILIALES_ID } from '../data/filiales';

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? ''/*http://localhost:3001*/
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const scope = sessionStorage.getItem('rh_filiale_scope');
  if (scope && scope !== ALL_FILIALES_ID) {
    config.headers['X-Filiale-Id'] = scope;
  }
  return config;
});

export default http;
